import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper'; 
import DataGridWrapper from '@/projects/syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { Button } from 'devextreme-react/button';
import { DataGrid, Popup, SelectBox } from 'devextreme-react';
import { inventoryService } from '../services/inventory-service';
import DateBox, { DateBoxTypes, DisplayFormat } from 'devextreme-react/cjs/date-box';
import { useNavigate } from 'react-router-dom';
import OrderStatusCell from '../order/components/order-status-celll';
import { SelectBoxTypes } from 'devextreme-react/cjs/select-box';

const InventoryList = () => {

    let SiteCode: any;
    let ProductCode: any;

    const dataGridRef = useRef<DataGrid>(null);
    const [store, setStore] = useState<CustomStore>();

    useEffect(() => {
        setStore(new CustomStore({
            key: ["locationCode", "productCode"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])

    const onGetOrderData = useCallback(async () => {
        if (SiteCode) {
            const x = await inventoryService.getOrderList(SiteCode, ProductCode);
            return x;
        }

    }, []);

    const onQuery = useCallback(async () => {
        dataGridRef.current?.instance.refresh();
    }, []);

    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

    const onValueChangedSite = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        SiteCode = e.value;
        getProductsLookups();
    }, []);

    const onValueChangedProduct = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        ProductCode = e.value;
    }, []);

    const navigate = useNavigate();
    const goToDetail = (siteCode: string, productCode: string) => {
        navigate(`/syncflow/inventory-detail/${siteCode}/${productCode}`, { state: { sitecode: siteCode, productcode: productCode } })
    }


    const [siteLookups] = useState(new CustomStore({
        load: inventoryService.getSiteLookups
    }));

    // const [productLookups] = useState(new CustomStore({
    //     load: inventoryService.getProductLookups("")
    // }));

    const [productLookups, setProducts] = useState();
    const getProductsLookups = async () => {
        setProducts(await inventoryService.getProductLookups(SiteCode))
    };


    return (
        <>
            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_list")}
                        type="default"
                        icon="refresh"
                        onClick={onQuery}
                    />
                </div>
            </div>

            <div className="row mb-12">
                <label className="col-lg-1 col-form-label fw-bold fs-6 required"> {t("syncflow:location")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="vendorLookups"
                                dataSource={siteLookups}
                                valueExpr="code"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onValueChangedSite}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">Product</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="vendorLookups"
                                dataSource={productLookups}
                                valueExpr="code"
                                displayExpr="name"
                                searchEnabled={true}
                                onValueChanged={onValueChangedProduct}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
            </div>


            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={true}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    excellExport={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: false,
                        updateMessageText: RemoveMessage('Resource'),
                    }}


                    columns={[
                        {
                            dataField: 'locationCode',
                            caption: t('syncflow:location_code'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'locationName',
                            caption: t('syncflow:location_name'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'productCode',
                            caption: t('syncflow:lb_product_code'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'productName',
                            caption: t('syncflow:lb_product_name'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'inventoryQty',
                            caption: "Closing Stock",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'diffInventoryQty',
                            caption: "Stock movements for today",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'calcInventoryQty',
                            caption: "Stock quantity",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'measureUnitCode',
                            caption: "Unit of measurement",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            caption: t('syncflow:lb_detail'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return (
                                    <Button
                                        text={t("syncflow:btn_detail")}
                                        type="default"
                                        icon='showpanel'
                                        stylingMode="contained"
                                        onClick={() => goToDetail(data.key.locationCode, data.key.productCode)}
                                    />
                                );
                            },
                        }
                    ]}
                />
            </React.Fragment>

        </>


    )
}
export default InventoryList